import type { ReactNode } from "react";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "@privacy/translations";
import { SparklesIcon } from "../../shared/icons";

export const AssistantGreeting = ({ children }: { children?: ReactNode }) => {
  const { t } = useTranslation();

  return (
    <Stack sx={{ flex: 1, alignItems: "center", justifyContent: "center", gap: 2, px: 3, textAlign: "center" }}>
      <SparklesIcon size={32} />
      <Typography sx={{ fontWeight: 600, fontSize: theme => theme.typography.pxToRem(24) }}>
        {t("Assistant.Empty.Greeting")}
      </Typography>
      <Typography sx={{ color: theme => theme.palette.text.tertiary, maxWidth: "36rem" }}>
        {t("Assistant.Empty.Hint")}
      </Typography>
      {children}
    </Stack>
  );
};
